import { useState, useEffect } from 'react';

interface AnimationState {
  contentVisible: boolean;
  buttonVisible: boolean;
}

interface UsePageTransitionOptions {
  contentDelay?: number;
  buttonDelay?: number;
}

export const usePageTransition = (options: UsePageTransitionOptions = {}) => {
  const { contentDelay = 100, buttonDelay = 300 } = options;

  const [animation, setAnimation] = useState<AnimationState>({
    contentVisible: false,
    buttonVisible: false,
  });

  useEffect(() => {
    // Reset animation state first
    setAnimation({
      contentVisible: false,
      buttonVisible: false,
    });

    const contentTimer = setTimeout(() => {
      setAnimation((prev) => ({ ...prev, contentVisible: true }));
    }, contentDelay);

    const buttonTimer = setTimeout(() => {
      setAnimation((prev) => ({ ...prev, buttonVisible: true }));
    }, buttonDelay);

    return () => {
      clearTimeout(contentTimer);
      clearTimeout(buttonTimer);
    };
  }, [contentDelay, buttonDelay]);

  const resetAnimation = () => {
    setAnimation({
      contentVisible: false,
      buttonVisible: false,
    });
  };

  return { ...animation, resetAnimation };
};
